export default "__VITE_ASSET__CvgVfZDe__"